<div class="row"><div class="col-md-2"></div><div class="col-md-8"><h1>New Print Section</h1><SectionForm></SectionForm></div><div class="col-md-2"></div></div>